import { useCallback } from 'react';
import { saveCollapsedColumns } from '../utils';

/**
 * useColumnCollapse Hook
 * 
 * Handles column collapse/expand logic with animations.
 */
const useColumnCollapse = ({
  campaignId,
  setCollapsedColumns,
  setExpandingColumns,
}) => {
  // Toggle column collapse state - persisted to localStorage
  const handleToggleCollapse = useCallback((columnId) => {
    setCollapsedColumns(prev => {
      const wasCollapsed = prev.has(columnId);
      const newSet = new Set(prev);
      
      if (wasCollapsed) {
        // Expanding - mark as expanding for animation
        newSet.delete(columnId);
        setExpandingColumns(exp => new Set([...exp, columnId]));
        // Clear the expanding state after animation completes
        setTimeout(() => {
          setExpandingColumns(exp => {
            const newExp = new Set(exp);
            newExp.delete(columnId);
            return newExp;
          });
        }, 700); // Match animation duration
      } else {
        newSet.add(columnId);
      }
      
      // Persist to localStorage
      saveCollapsedColumns(campaignId, newSet);
      
      return newSet;
    });
  }, [campaignId, setCollapsedColumns, setExpandingColumns]);

  return { handleToggleCollapse };
};

export default useColumnCollapse;

